import $ from '@vaersaagod/tools/Dom';

export default el => {
    const $el = $(el);
    const $moreLink = $el.find('[data-history-more-link]');
    const $moreLinkWrap = $el.find('[data-history-more-link-wrap]');
    const $moreWrap = $el.find('[data-history-content]');
    
    let isExpanded = false;
    
    const showMore = () => {
        $el.addClass('-open');
        
        $moreWrap.css({ height: 'auto' });
        const targetHeight = $moreWrap.height();
        $moreWrap.css({ height: 0 });
        
        TweenLite.to($moreWrap.nodes, 0.6, { height: targetHeight, ease: Quart.easeInOut, onComplete: () => {
            $moreWrap.css({ height: 'auto' }); 
        } });
        
        TweenLite.to($moreLinkWrap.nodes, 0.1, { autoAlpha: 0 });
        
        isExpanded = true;
    };
    
    const showLess = () => {
        $el.removeClass('-open');
        $moreWrap.css({ height: $moreWrap.height() });
        
        TweenLite.to($moreWrap.nodes, 0.6, { height: 0, ease: Quart.easeInOut, onComplete: () => {
            $moreWrap.css({ height: '' }); 
        } });
        
        TweenLite.to($moreLinkWrap.nodes, 0.1, { autoAlpha: 1 });
        
        isExpanded = false;
    };
    
    const init = () => {
        $moreLink.on('click', e => {
            e.preventDefault();
            if (isExpanded) {
                showLess();
            } else {
                showMore();
            }
        });
    };

    const destroy = () => {
        $moreLink.off('click');
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/HistoryArticle.js